export enum ExportType {
  FULFILLMENT_CONTEXTS = 'fulfillment_contexts',
  TENANTS = 'tenants',
  ORIGINS = 'origins',
  CARRIER_CONTRACTS = 'carrier_contracts',
  CARRIER_RATES = 'carrier_rates',
}

export enum ExportMode {
  DETAILED = 'detailed',
  CONSOLIDATED = 'consolidated',
}

export interface ExportRequestDto {
  username: string;
  password: string;
  accessToken?: string;
  exportType: ExportType;
  exportMode: ExportMode;
  /** Fulfillment Contexts exports: true = every FC, false = only fulfillmentContextIds. */
  exportAllFCs?: boolean;
  fulfillmentContextIds?: string[];
  tenantIds?: string[];
  partnerId?: string;
  includeRateCards?: boolean;
  includeThirdPartyBilling?: boolean;
  includeInjectionProfiles?: boolean;
  includeLanes?: boolean;
  includeLabelAugmentations?: boolean;
  includeOrigins?: boolean;
  includeCarrierSchedules?: boolean;
  includeIncompleteFcs?: boolean;
}

/** Jobs created before FC selection hold only booleans. */
export type ExportRequestOptions = Record<string, boolean | string[]>;

export interface FulfillmentContextSummary {
  fulfillmentContextId: string;
  name: string;
  tenantId?: string;
}

export interface ExportResponseDto {
  jobId: string;
  message: string;
  estimatedTime: number;
}

export interface ExportJobDto {
  jobId: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  exportType: string;
  exportMode?: string;
  partnerName?: string;
  userId?: string;
  createdAt: Date;
  completedAt?: Date;
  progress: number;
  files: string[];
  error?: string;
  totalItems: number;
  successfulItems: number;
  failedItems: number;
  requestOptions?: ExportRequestOptions;
}

export interface ExportTypeOption {
  value: ExportType;
  label: string;
  description: string;
}
